"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgramTable = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _uiKit = require("@cian/ui-kit");
var React = _interopRequireWildcard(require("react"));
var _constants = require("./constants");
var styles = _interopRequireWildcard(require("./ProgramTable.css"));
var _components = require("./components");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ProgramTable = _ref => {
  let {
    items,
    showEscrow,
    onProgramSelect,
    onLabelClick
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['container']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['header']
  }, _constants.HEADERS.map((header, index) => /*#__PURE__*/React.createElement(_uiKit.UIText2, {
    key: index,
    color: "gray40_100",
    textAlign: index !== 0 ? 'right' : 'left'
  }, header))), items.map(program => /*#__PURE__*/React.createElement(_components.ProgramRow, (0, _extends2.default)({}, program, {
    key: program.id,
    onProgramClick: () => onProgramSelect(program),
    onLabelClick: event => {
      event.stopPropagation();
      onLabelClick(program.id);
    },
    showEscrow: showEscrow
  }))));
};
exports.ProgramTable = ProgramTable;